import RouterLoadingScreen from "components/loading-screen/RouterLoadingScreen";
import { useState, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { APP_URLS } from "urls/AppUrls";
import useAuth from "../hooks/useAuth";

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isInitialized, user } = useAuth();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  if (!isInitialized) {
    return <RouterLoadingScreen />;
  }

  if (!isAuthenticated || !user) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={APP_URLS.LOGIN} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
